module.exports = __webpack_public_path__ + "img/fin.9e7d3d5d.svg";